import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import { PremiumUploadGameEditionCover, UploadGameEditionCover } from "./UploadGameEditionCover";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").GameEditionId} props.editionId
 */
export const GameEditionCoverUpload = ({ gameId, editionId }) => {
  const { data: entitlements } = useMyEntitlements();
  const hasLargeFileUploads = entitlements && entitlements.hasLargeFileUploads;

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2">Edition Cover</Typography>
      {hasLargeFileUploads ? (
        <PremiumUploadGameEditionCover gameId={gameId} editionId={editionId} />
      ) : (
        <UploadGameEditionCover gameId={gameId} editionId={editionId} />
      )}
      <Typography variant="body2" textAlign="right" color="text.secondary">
        Maximum file size: {hasLargeFileUploads ? "500MB" : "5MB"}
      </Typography>
    </Stack>
  );
};
